import React, { useRef } from "react";
import SvgMultiProcole from "../../_svg/MultiProtocole";
import { withTranslation } from 'react-i18next';

const App = (props) => {
  const ref = useRef();
  const { t } = props
  const content = {
    title: t('applications.saphir.multi.protocol'),
    description: t('applications.saphir.multi.protocol.description')
  }
  return (
              <div className={"svg-container"} id={"svg-site-saphir"} itemScope itemType="https://schema.org/WebPage">
                  <div>
                    <SvgMultiProcole fill={"#b77830"}/>
                <h3 itemProp="alternativeHeadline">{content.title}</h3>
                    <span itemProp="description">
                      {content.description}
                    </span>
                  </div>
              </div>
  );
};

const tr = withTranslation()(App);
export default tr;
